import React, { ReactNode, useEffect, useState } from 'react';
import { Spinner } from 'reactstrap';
import { v4 as uuidv4 } from 'uuid';

import styled, { css, keyframes } from 'styled-components';
import ImageUploader from 'react-images-upload';
import * as loadImage from 'blueimp-load-image';

// import MainLayout from '../common/Layout';
import MainLayout, { media } from '../../common/Layout';
import { GetSimilarImageParamType } from '../../../lib/tabSimilarImage/type';
import { tabSimilarImageState } from '../../../modules/tabSimilarImage';
import ImageList from './itemList/ImageList';

import config from '../../../lib/config-api.json';

const env = process.env.NODE_ENV;
let { apiInfo } = config;

if (env === 'development') {
  apiInfo = config.apiInfo_dev;
}

interface styleType {
  isLoadingImage?: boolean;
}

const SimilarImageComponent = styled(MainLayout)`
  max-width: 90%;
`;

const ObjectRecognitionContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  flex-grow: 1;
  padding: 0;

  /* Mobile Device */
  /* max-width: 1000px; */
  width: 100%;
  ${media.desktop`  
  /* max-width: 690px; */
  width: 40%;
  `};
`;

const SimilarImageContent = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 0;

  /* Mobile Device */
  /* max-width: 1000px; */
  margin-left: 0px;
  width: 100%;

  ${media.desktop`  
  width: 50%;
    /* max-width: 600px; */
    margin-left: 60px;
  `};
`;

const SimilarImageWrapper = styled.div`
  margin-top: 24px;
  width: 100%;
  min-height: 200px;
  border-radius: 8px;
  border: solid 1px #e1e6f0;
  padding: 20px;

  /* Mobile Device */
  margin-top: 26px;
  margin-bottom: 26px;

  ${media.desktop`
    margin-top: 24px;
    margin-bottom: 0px;
  `};
`;

const ImageResultTitleBox = styled.div`
  display: flex;
  align-items: center;
  height: 30px;
`;

const ImageResultTitleText = styled.div`
  font-family: 'NotoKrM';
  font-size: 18px;
  font-weight: 500;
  /* height: 100%; */
`;

const ImageResultTitleDesc = styled.div`
  font-family: 'NotoKrR';
  font-size: 12px;
  margin-left: 10px;
  /* height: 100%; */
`;

const ImageInputWrapper = styled.div``;
const ImageInput = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 24px;
  border-radius: 8px;
  border: solid 1px #e1e6f0;
  height: 200px;
  .fileContainer {
    background: transparent;
    box-shadow: none;
  }
`;
const ImageResultWrapper = styled.div`
  margin-top: 24px;
  width: 100%;
  border-radius: 8px;
  border: solid 1px #e1e6f0;
  padding: 20px;

  /* Mobile Device */
  margin-top: 26px;
  margin-bottom: 26px;

  ${media.desktop`
    margin-top: 24px;
    margin-bottom: 0px;
  `};
`;
const ImageResultBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  /* min-height: 200px; */
`;

const ImageResultimg = styled.img`
  margin-top: 15px;
  border-radius: 6px;
  width: 100%;
`;

const ImageNoneTitle = styled.div`
  align-items: center;
  font-family: 'NotoKrR';
  font-size: 16px;
  height: 200px;
  ${(props: styleType) => {
    if (!props.isLoadingImage) {
      return css`
        display: flex;
      `;
    }
    return css`
      display: none;
    `;
  }}
`;

const SpinnerBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  ${(props: styleType) => {
    if (props.isLoadingImage) {
      return css`
        display: flex;
      `;
    }
    return css`
      display: none;
    `;
  }}
`;

type SimilarImageProps = {
  onGetSimilarImage: (info: GetSimilarImageParamType) => void;
  onSetSimilarImageDataNull: () => void;
  loading: tabSimilarImageState['loading'];
  similar_image_data: tabSimilarImageState['similar_image_data'];
};

const SimilarImage = ({
  onGetSimilarImage,
  onSetSimilarImageDataNull,
  loading,
  similar_image_data,
}: SimilarImageProps) => {
  const [pictures, setPictures] = useState<string | null>(null);

  const addImageProcess = (src: string): Promise<any> => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = src;
      img.onload = () =>
        resolve({ width: img.naturalWidth, height: img.naturalHeight });
      img.onerror = reject;
    });
  };

  const rebuildImageList = () => {
    const src_base = apiInfo.api_url_si_image;
    const reBuildImageData: {
      id: string;
      url: string;
      src: string;
      width: number;
      height: number;
      alt: string;
      targetId?: number;
      title?: string | undefined;
      desc?: string | undefined;
      source?: string | undefined;
    }[] = [];

    if (similar_image_data && similar_image_data.length > 0) {
      similar_image_data.forEach(async (element, index) => {
        if (index === 0) {
          return;
        }

        const size = await addImageProcess(`${src_base}/${element.img}`);
        // const imgObj = new Image();
        // imgObj.src = `${src_base}/${element.img}`;

        reBuildImageData.push({
          id: uuidv4(),
          url: '',
          src: `${src_base}/${element.img}`,
          alt: '유사이미지 결과입니다.',
          width: size.width,
          height: size.height,
          targetId: 3,
          title: 'none',
          desc: 'none',
          source: `${(element.dis * 100).toFixed(0)}%`,
        });
      });
    }

    return reBuildImageData;
  };

  const makeList = (): ReactNode[] | null => {
    const resultReactNode: ReactNode[] | null = [];
    const photoData = rebuildImageList();
    resultReactNode.push(
      <ImageList
        photoData={photoData}
        // selectPhotoData={selectPhotoData}
        // onSetIsDetailViewOpen={onSetIsDetailViewOpen}
        // onSetSelectPhotoData={onSetSelectPhotoData}
        key={0}
      />
    );
    return resultReactNode;
  };

  const onDrop = (files: File[], pictures: string[]) => {
    onGetSimilarImage({ image: files[0] });
    const url = URL.createObjectURL(files[0]);
    setPictures(url);
  };

  return (
    <SimilarImageComponent>
      {/* 왼쪽 패널 */}
      <ObjectRecognitionContent>
        {/* 이미지 인풋 */}
        <ImageInputWrapper>
          <ImageInput>
            <form>
              <ImageUploader
                withIcon
                onChange={onDrop}
                buttonText="파일을 선택해주세요."
                imgExtension={['.jpg', '.gif', '.png', '.gif', '.jpeg']}
                maxFileSize={52428800}
                fileSizeError="파일 크기는 50mb 를 넘을 수 없습니다."
                fileTypeError="지원하지 않는 포맷 입니다."
                label="최대 파일 크기는 50 MB 입니다."
                singleImage
              />
            </form>
          </ImageInput>
        </ImageInputWrapper>
        {/* 객체 인식 */}
        <ImageResultWrapper>
          <ImageResultTitleBox>
            <ImageResultTitleText>객체 인식 결과</ImageResultTitleText>
          </ImageResultTitleBox>
          <ImageResultBox>
            {similar_image_data ? (
              <ImageResultimg
                src={`${apiInfo.api_url_si_image}/${similar_image_data[0].img}`}
                alt="Generic placeholder"
              />
            ) : (
              <ImageNoneTitle isLoadingImage={loading}>
                객체 인식 결과가 표시 됩니다.
              </ImageNoneTitle>
            )}
            <SpinnerBox isLoadingImage={loading}>
              <Spinner color="primary" />
            </SpinnerBox>
          </ImageResultBox>
        </ImageResultWrapper>
      </ObjectRecognitionContent>
      {/* 오른쪽 패널 */}
      <SimilarImageContent>
        {/* 유사이미지 */}
        <ImageResultWrapper>
          <ImageResultTitleBox>
            <ImageResultTitleText>유사이미지</ImageResultTitleText>
            {/* <ImageResultTitleDesc>
              유사도가 높을수록 1에 수렴합니다.
            </ImageResultTitleDesc> */}
          </ImageResultTitleBox>
          <ImageResultBox>
            {similar_image_data ? (
              makeList()
            ) : (
              <ImageNoneTitle isLoadingImage={loading}>
                유사 이미지 결과가 표시 됩니다.
              </ImageNoneTitle>
            )}

            <SpinnerBox isLoadingImage={loading}>
              <Spinner color="primary" />
            </SpinnerBox>
          </ImageResultBox>
        </ImageResultWrapper>
      </SimilarImageContent>
    </SimilarImageComponent>
  );
};

export default SimilarImage;
